import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { GetQuoteComponent } from 'src/app/shared/elements/get-quote/get-quote.component';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';
import { FormFooterService } from 'src/app/services/form-footer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

export function noNumericAfterDotComValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null | any => {
    const companyEmail = control?.value as string;
    const afterDotCom = companyEmail?.substring(companyEmail.lastIndexOf('@'));
    const textSearch = afterDotCom?.substring(afterDotCom.indexOf('.'));
    const containsNumbers = /\d+/g;
    if (textSearch?.match(containsNumbers)) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    } else if (afterDotCom?.includes('.') != true) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    }
  };
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  baseUrl = environment.BASE_URL;
  assetsUrl = environment.ASSETS_URL;
  portalUrl: string = environment.PORTAL_URL;
  catForm!: FormGroup;
  catValue: any;
  isCapabilityFormActive: boolean = false;
  capabilityName: string = '';

  slickCarouselConfig: any;
  slickCapabilitesConfig: any;

  categoryData: any[] = [];

  countryData: any[] = [];
  customerForm!: FormGroup;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  showWaiting: boolean = false;
  showform: boolean = false;
  intervalId: any;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  routerLink:string | undefined ='';
  isTermsConditionCheckedFlag: boolean = false;
  constructor(
    private dialog: MatDialog,
    private service: CommonService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private inquiry: FormFooterService,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    this.slickCarouselConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1190,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
          },
        },
      ],
    };
    // this.slickCapabilitesConfig = {
    //   slidesToShow: 4,
    //   slidesToScroll: 4,
    //   dots: true,
    //   infinite: true,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    //   responsive: [
    //     {
    //       breakpoint: 1190,
    //       settings: {
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 2.1,
    //         dots: true,
    //       },
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         slidesToShow: 2.1,
    //         dots: true,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1.1,
    //         centerMode: false,
    //         dots: true,
    //       },
    //     },
    //   ],
    // };
    this.slickCapabilitesConfig = {
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1190,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            dots: true,
          },
        },
      ],
    };
  }
  ngOnInit() {
    const namePattern = /^[a-zA-Z ]+$/;

    this.customerForm = this.fb.group({
      username: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.pattern(namePattern),
        ],
      ],
      companyEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          noNumericAfterDotComValidator(),
        ],
      ],
      phone: ['', [Validators.required]],
      comments: [''],
      companyName: ['', [Validators.required]],
      queryFor: ['', [Validators.required]],
      isChecked: [false, Validators.required],
    });

    this.catForm = this.fb.group({
      category: ['0', Validators.required],
    });
    // this.getCategory();
    // this.getCountry();
    // Set up the interval to open the modal every 30 second
    this.intervalId = setTimeout(() => {
      this.openCapabilityFormAutomatically();
    }, 30000); // 30000 milliseconds = 1/2 minute

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (document.hidden) {
      //this.openCapabilityFormAutomatically();
    }
  };

  openCapabilityFormAutomatically() {
    if (!this.isCapabilityFormActive) {
      this.isCapabilityFormActive = true; // Open the modal
      this.showform = true;
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId); // Clean up the interval when the component is destroyed
    }
  }
  getCategory() {
    this.service
      .getData(`${this.baseUrl}common-service/category-management`)
      .subscribe((res) => {
        this.categoryData = res?.response;
        this.catForm.patchValue({
          category: res?.response[0].id,
        });
      });
  }

  catSubmit() {
    this.catValue = this.catForm.value.category[0];
    if (this.catValue !== undefined && this.catValue !== null) {
      sessionStorage.setItem('category_value', this.catValue);
      const dialogRef = this.dialog.open(GetQuoteComponent);
      this.catForm.reset();
    }
  }
  customerSignup() {
    this.router.navigate(['/registration']);
    //window.open(`${this.portalUrl}/user-register`, '_blank');
  }
  openModal() {
    const dialogRef = this.dialog.open(GetQuoteComponent);
  }
  imcustomer(isCapabilityFormActive: boolean) {
    let payload = {};
    if (isCapabilityFormActive) {
      payload = {
        username: this.customerForm.value.username,
        companyEmail: this.customerForm.value.companyEmail,
        phone: this.customerForm.value.phone?.e164Number,
        countryCode: this.customerForm.value.phone?.countryCode,
        company: this.customerForm.value.companyName,
        isForCapability:true,
        capability: this.capabilityName,
        queryFor: this.customerForm.value.queryFor,
      };
    } else {
      payload = {
        username: this.customerForm.value.username,
        companyEmail: this.customerForm.value.companyEmail,
        phone: this.customerForm.value.phone?.e164Number,
        countryCode: this.customerForm.value.phone?.countryCode,
        comments: this.customerForm.value.comments,
      };
    }
    let url = '';
    let usertype = '';
    if(this.customerForm.value.queryFor == 'Corporate Customer'){
      url = `${this.baseUrl}customer/lead-management/createCorporateCustomerDeal`;
      usertype = 'Customer';
    } else{
      url = `${this.baseUrl}supplier/lead-management/createCorporateSupplierDeal`
      usertype = 'Supplier';
    }
    this.pushFileDownloadEvent();
    this.service
      .postDatawithoutHeaders(url, payload)
      .subscribe({
        next: (res: any) => {
          this.toastr.success(`${usertype} Form submitted successfully!`);
          this.customerForm.reset();
          this.isTermsConditionCheckedFlag = false;
          this.showWaiting = false; // Hide the waiting message
          this.showform = false; // Show the form again
          this.showWaiting = true;
          this.downloadCapfile();
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
          this.showWaiting = false; // Hide the waiting message
          this.showform = true; // Show the form again
        },
      });
  }

  pushFileDownloadEvent() {
    const gtmTag = {
      event: 'Customer_Onboarding-Step-1',
      event_category: 'User Input',
      username: this.customerForm.value.username,
      companyEmail: this.customerForm.value.companyEmail,
      phone: this.customerForm.value.phone?.e164Number,
      capabilityName: this.capabilityName,
    };
    this.gtmService.pushTag(gtmTag);
  }
  getCountry() {
    this.service
      .getData(`${this.baseUrl}common-service/country-management`)
      .subscribe((res) => {
        this.countryData = res?.response;
      });
  }
  resetForm() {
    this.customerForm.reset();
  }
  isValid() {
    if (
      this.customerForm.controls['username'].status === 'INVALID' ||
      this.customerForm.controls['companyEmail'].status === 'INVALID' ||
      this.customerForm.controls['phone'].status === 'INVALID'
    ) {
      return true;
    } else {
      return false;
    }
  }

  isTermsConditionChecked(): boolean {
    if (this.isTermsConditionCheckedFlag) {
      return false;
    }
    return true;
  }

  isCapabilityFormValid(): boolean {
    if (
      this.customerForm.controls['username'].status === 'INVALID' ||
      this.customerForm.controls['companyEmail'].status === 'INVALID' ||
      this.customerForm.controls['phone'].status === 'INVALID' ||
      this.customerForm.controls['companyName'].status === 'INVALID' ||
      this.customerForm.controls['isChecked'].status === 'INVALID'
    ) {
      return true;
    } else {
      return false;
    }
  }
  openCapabilityForm(capName: string, routerLink?:string) {
    this.capabilityName = capName;
    this.isCapabilityFormActive = true;
    this.showform = true;
    this.routerLink = routerLink;
  }
  closeCapabilityForm() {
    this.capabilityName = '';
    this.resetForm();
    this.showWaiting = false; // Hide the waiting message
    this.showform = false; // Show the form again
    this.isCapabilityFormActive = false; 
  }
  downloadCapfile() {
    this.closeCapabilityForm();
    let link = document?.createElement('a');
    link.href = `${this.assetsUrl}Unibuild-Capability.pdf`;
    link.download = 'Capability';
    link.target = '_blank';
    link.click();
  }
  openTerms(path: string) {
    const url = this.router.serializeUrl(this.router.createUrlTree([path]));
    window.open(url, '_blank');
  }
}
